import React from 'react'
import { useSelector } from 'react-redux'
import authPersistSelectors from '../../../../../store/selectors/auth.persist.selectors'
import { useParams } from 'react-router'
import { useState } from 'react'
import { ImportQuestionDefinitionModal } from './ImportQuestionDefinitionModal'
import { ExportOutlined, ImportOutlined } from '@ant-design/icons'
import { useLazyExportQuestionDefinitionQuery } from '../../../../../store/apis/developer-mode.api'
import fileDownload from 'js-file-download'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { Button } from 'antd'
import { useAssignmentAccess } from '../../../components/access/Access'
import { TextContentRules } from '../../../components/access/access-rules/assignment-rules'

export const QuestionDefinitionActions = ({ question }) => {
    const isDeveloperMode = useSelector(authPersistSelectors.isDeveloperMode)
    const assignmentName = useSelector(assignmentSelectors.name)
    const { token } = useParams()
    const [showExportQuestionDefinitionModal, setShowExportQuestionDefinitionModal] = useState(false)

    const { hasAccess: hasImportingPermission } = useAssignmentAccess(
        TextContentRules.EDIT_GRADINGS,
        token,
    )

    const [exportQuestionDefinition, exportQuestionDefinitionResult] = useLazyExportQuestionDefinitionQuery()

    if (!isDeveloperMode) {
        return null
    }

    const onExport = async () => {
        const response = await exportQuestionDefinition({ token, questionId: question?.key })

        if ('data' in response)
            fileDownload(
                response.data,
                question ? `${question.name}-definition.json` : `${assignmentName}-question-definition.json`,
            )
    }

    const onImport = () => {
        setShowExportQuestionDefinitionModal(true)
    }

    return (
        <>
            <Button
                shape='circle'
                type='text'
                aria-label='Export question definition'
                title='Export Question Definition'
                onClick={onExport}
            >
                <ExportOutlined
                    className='primary-color'
                    style={{ fontSize: 16 }}
                    disabled={exportQuestionDefinitionResult.isLoading}
                />
            </Button>
            {hasImportingPermission && (
            <Button
                shape='circle'
                type='text'
                aria-label='Import question definition'
                title='Import Question Definition'
                onClick={onImport}
                disabled={exportQuestionDefinitionResult.isLoading}
            >
                    <ImportOutlined style={{ fontSize: 16 }} className='primary-color' />
                </Button>
            )}
            {showExportQuestionDefinitionModal && (
                <ImportQuestionDefinitionModal
                    question={question}
                    setShowExportQuestionDefinitionModal={setShowExportQuestionDefinitionModal}
                />
            )}
        </>
    )
}

export default QuestionDefinitionActions
